import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A9TimeSeriesEdit } from "./edit";
import { A9TimeSeriesNew } from "./new";
import { A9TimeSeriesTable } from "./table";

export default function A9TimeSeries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Valorisation");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A9TimeSeriesEdit />} />
      <Route index element={<A9TimeSeriesTable />} />
      <Route path="/new" element={<A9TimeSeriesNew />} />
    </Routes>
  );
}
